import { initializeApp } from 'firebase/app';
import type { Analytics } from 'firebase/analytics';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyBpX_wPiLh8lFC_hrtNw1-W3IfYC7Idt1M',
  authDomain: 'base64-encode-decode-20efb.firebaseapp.com',
  projectId: 'base64-encode-decode-20efb',
  storageBucket: 'base64-encode-decode-20efb.firebasestorage.app',
  messagingSenderId: '114754642490',
  appId: '1:114754642490:web:1aa2e952e9ee02541f0b03',
  measurementId: 'G-RNV6Q4TGZD',
};

const app = initializeApp(firebaseConfig);

// Analytics is loaded lazily so the Firebase Analytics SDK never blocks the
// initial render (better Core Web Vitals). Events fired before it is ready are
// queued and flushed once initialization completes.
let analytics: Analytics | null = null;
let analyticsReady = false;
const pendingEvents: Array<{ name: string; params?: { [key: string]: any } }> = [];

function flushPending() {
  if (!analytics) return;
  // Lazily require logEvent alongside the loaded analytics instance.
  import('firebase/analytics').then(({ logEvent }) => {
    pendingEvents.splice(0).forEach((e) => logEvent(analytics!, e.name, e.params));
  });
}

// react-snap renders pages in a headless browser with a "ReactSnap" user agent.
// Skip analytics entirely during prerendering so its network calls never delay
// (or hang) the static HTML capture.
function isPrerendering() {
  return typeof navigator !== 'undefined' && /ReactSnap/i.test(navigator.userAgent);
}

function initAnalytics() {
  if (analyticsReady || typeof window === 'undefined' || isPrerendering()) return;
  analyticsReady = true;
  import('firebase/analytics')
    .then(async ({ getAnalytics, isSupported }) => {
      if (await isSupported()) {
        analytics = getAnalytics(app);
        flushPending();
      }
    })
    .catch(() => {
      /* analytics is non-critical; ignore failures */
    });
}

// Kick off analytics during browser idle time, after first paint.
if (typeof window !== 'undefined' && !isPrerendering()) {
  const w = window as any;
  const schedule = (cb: () => void) =>
    typeof w.requestIdleCallback === 'function'
      ? w.requestIdleCallback(cb)
      : w.setTimeout(cb, 2000);
  schedule(initAnalytics);
}

// Analytics event logger. Safe to call at any time; queues until ready.
export const logAnalyticsEvent = (eventName: string, eventParams?: { [key: string]: any }) => {
  if (analytics) {
    import('firebase/analytics').then(({ logEvent }) => logEvent(analytics!, eventName, eventParams));
  } else {
    pendingEvents.push({ name: eventName, params: eventParams });
    initAnalytics();
  }
};

export default app;
